var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C14.82 1.25 18.75 5.18 18.75 10C18.75 14.82 14.82 18.75 10 18.75C5.18 18.75 1.25 14.82 1.25 10C1.25 5.18 5.18 1.25 10 1.25ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.67 9.99998H7.39997C6.88997 9.99998 6.46997 9.57998 6.46997 9.06998V6.65998C6.46997 6.14998 6.88997 5.72998 7.39997 5.72998H14.1",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32001 10H12.59C13.1 10 13.52 10.42 13.52 10.93V13.33C13.52 13.84 13.1 14.26 12.59 14.26H5.89001",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.37988V5.73988",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.27V16.62",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsIcon);
export default __webpack_public_path__ + "static/media/rewardsIcon.a6cb3f431a4f517ad0e0ad3359ab2f9c.svg";
export { ForwardRef as ReactComponent };